import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const HotellionInstallationForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<>
			<FormInput
				name="settings.login"
				errors={errors}
				register={register}
				label={t("modules.app.field.login.title")}
			/>
			<FormInput
				name="settings.password"
				errors={errors}
				register={register}
				label={t("lib:common.word.password")}
			/>
			<FormInput
				name="settings.clientid"
				errors={errors}
				register={register}
				label={t("modules.app.field.client_id.title")}
			/>
			<FormInput
				name="settings.clientsecret"
				errors={errors}
				register={register}
				label={t("modules.app.field.client_secret.title")}
			/>
			<FormInput
				name="settings.url"
				errors={errors}
				register={register}
				label={t("modules.app.field.url.title")}
			/>
		</>
	);
};

export default HotellionInstallationForm;
